import { tr, type Lang } from "./lang";

/**
 * Mailsprache beim Speichern des Profils (SICHT-CREATOR-17): Das Profil schreibt die Sprache nur dann an alle Profile
 * (talents.language), wenn die Person ihre Sprache dort wirklich geändert hat. Vorher setzte jedes Speichern, etwa einer
 * neuen Adresse, die je Agentur gewählte Mailsprache (Benachrichtigungen) still auf die Portalsprache zurück, auch „wie
 * dein Portal“ (null). loaded ist user_preferences.language, shown die Sprache, die das Feld beim Laden zeigte.
 */
export function mailLanguageToSave(loaded: string | null | undefined, shown: Lang, chosen: string): Lang | null {
  if (chosen !== "de" && chosen !== "en") return null;
  return chosen === (loaded === "de" || loaded === "en" ? loaded : shown) ? null : chosen;
}

/**
 * Name einer Mailsprache im Fließtext (SICHT-CREATOR-28): einheitlich in Konto, Benachrichtigungen und der Zusammenfassung;
 * auf Englisch „German“ statt „Deutsch“.
 */
export function mailLanguageName(l: Lang, lang: Lang): string {
  return l === "en" ? "English" : tr(lang, "Deutsch", "German");
}

/**
 * Sprache der Mails einer Agentur in Worten (Konto, Benachrichtigungen): talents.language, sonst wie die Datenbank
 * (app.talent_language, 0041: eigene Portalsprache vor der Sprache der Agentur), also die Sprache des Portals.
 */
export function mailLanguageText(talentLanguage: string | null | undefined, portal: Lang, lang: Lang): string {
  const name = (l: Lang) => mailLanguageName(l, lang);
  return talentLanguage === "de" || talentLanguage === "en"
    ? name(talentLanguage)
    : tr(lang, `wie dein Portal (${name(portal)})`, `same as your portal (${name(portal)})`);
}
